import { ReactNode } from 'react';
import { TextSize, TextSpan } from './Text';

interface TextButtonProps {
  children: ReactNode;
  onClick: () => void;
  size?: TextSize;
  className?: string;
  disabled?: boolean;
}

/** An action that reads as a link, in the app's call-to-action colour. */
export const TextButton = ({ children, onClick, size = 'sm', className = '', disabled }: TextButtonProps) => (
  <button
    type="button"
    className={`hover:underline disabled:opacity-50 disabled:no-underline ${className}`}
    disabled={disabled}
    onClick={onClick}>
    <TextSpan
      size={size}
      color="indigoCTA">
      {children}
    </TextSpan>
  </button>
);
